"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeItems = removeItems;
exports.subset = subset;
exports.objHasAttrs = objHasAttrs;
exports.throwIfDoesContain = throwIfDoesContain;
exports.throwIfDoesNotContain = throwIfDoesNotContain;
exports.throwIfContainsExtra = throwIfContainsExtra;
exports.removeEmptyStrings = removeEmptyStrings;
/*! Copyright (c) 2019, XAPPmedia */
__exportStar(require("./findValueForKey"), exports);
__exportStar(require("./findValuesForKey"), exports);
__exportStar(require("./percentComplete"), exports);
/**
 * A function that's the opposite of "subset" in which it will remove the attributes that are given in the function.
 *
 * The original object is not affected.
 *
 * @param obj Object to remove the items from.
 * @param attrs The attribute keys to remove from the object. It can be strings for generic javascript objects or
 *      numbers for arrays.
 *      It can also be a function that returns a boolean where "true" means to keep and "false" means to remove.
 *      In the case for functions, the first parameters will be the "key" of the object (string for objects and numbers for arrays.).
 *
 */
function removeItems(obj, attrs) {
    if (!obj) {
        return obj;
    }
    if (!attrs || attrs.length === 0) {
        return Object.assign({}, obj);
    }
    const objIsArray = Array.isArray(obj);
    const returnObj = objIsArray ? obj.slice() : Object.assign({}, obj);
    const deleteItem = (key) => {
        if (objIsArray) {
            returnObj.splice(key, 1);
        }
        else {
            delete returnObj[key];
        }
    };
    if (typeof attrs === "function") {
        // Reverse order in case it's an array so it shrinks it appropriately.
        Object.keys(obj)
            .reverse()
            .forEach((key) => {
            if (!attrs(key, returnObj[key])) {
                deleteItem(key);
            }
        });
    }
    else {
        attrs.reverse().forEach((value) => {
            deleteItem(value);
        });
    }
    return returnObj;
}
/**
 * A function that will return a subset of a given object keeping only the attributes that it contains.
 *
 * The original object is not affected.
 *
 * @param obj Object to create a subset for.
 * @param attrs The attributes to retain in the object.
 */
function subset(obj, attrs) {
    if (!obj) {
        return obj;
    }
    if (!attrs || attrs.length === 0) {
        return {};
    }
    const check = obj;
    const returnObj = {};
    attrs.forEach((value) => {
        if (check.hasOwnProperty(value)) {
            returnObj[value] = check[value];
        }
    });
    return returnObj;
}
/**
 * A utility function to determine if an object has attributes or not.
 *
 * @param obj Object to check
 * @returns True if the object exists and has attributes or false otherwise.
 */
function objHasAttrs(obj) {
    const testObj = obj || {};
    return Object.keys(testObj).length > 0 && testObj.constructor === Object;
}
function defaultValidationErrorHandler(keys, error) {
    throw error;
}
/**
 * A validation function that can check if an object contains an attribute that is should not have.
 * @param obj The object to check.
 * @param requiredAttrs The attributes that are not allowed.
 * @param onError An optional error handler that allows for custom messages or actions.  The keys passed in will be the keys that are banned which are contained in the item.
 */
function throwIfDoesContain(obj, bannedAttrs, onError = defaultValidationErrorHandler) {
    if (!obj || !bannedAttrs || bannedAttrs.length === 0) {
        // It obviously does not contain the items.
        return;
    }
    const sub = subset(obj, bannedAttrs);
    const keys = Object.keys(sub);
    if (keys.length > 0) {
        const error = new Error("Object can not contain keys: '" + keys.join(", ") + "'.");
        onError(keys, error);
    }
}
/**
 * A validation function that can check if an object contains the required attributes and throws an error if they are not part of it.
 * @param obj Object to check
 * @param requiredAttrs The attributes in the object that are required.
 * @param undefinedPermitted True if the object is allowed to be undefined.  Default is false in which case an error will be thrown.
 * @param onError An optional error handler that allows for custom messages or actions.  The keys passed in will be the keys that were required but are not inside the object.
 */
function throwIfDoesNotContain(obj, requiredAttrs, undefinedPermitted, onError = defaultValidationErrorHandler) {
    if (!obj) {
        if (undefinedPermitted) {
            return;
        }
        else {
            throw new Error("Object can not be undefined.");
        }
    }
    if (!requiredAttrs || requiredAttrs.length === 0) {
        // There's nothing required so let it go.
        return;
    }
    const subs = subset(obj, requiredAttrs);
    const keys = Object.keys(subs);
    if (keys.length !== requiredAttrs.length) {
        const difference = requiredAttrs.filter((key) => {
            return keys.indexOf(key) < 0;
        });
        const error = new Error("Object must contain keys: '" + difference.join(", "));
        onError(difference, error);
    }
    // Rejoice!
}
/**
 * A validation function that can check an object contains properties that should not exist in the object.
 * @param obj The object to check.
 * @param restrictAttrs The attributes to restrict to the object to.  Will not check if empty.
 * @param undefinedPermitted Set to true if the object is allowed to be undefined.  Default is false in which case an error will be thrown.
 * @param onError An optional error handler that allows for custom messages or actions.  The keys passed in will be the keys that were not allowed in the object but were.
 */
function throwIfContainsExtra(obj, restrictAttrs, undefinedPermitted, onError = defaultValidationErrorHandler) {
    if (!obj) {
        if (undefinedPermitted) {
            return;
        }
        else {
            throw new Error("Object can not be undefined.");
        }
    }
    if (!restrictAttrs || restrictAttrs.length === 0) {
        return;
    }
    const removed = removeItems(obj, restrictAttrs);
    const keys = Object.keys(removed);
    if (keys.length > 0) {
        const error = new Error("Object does not pass validation. Keys: '" + keys.join(", ") + "' are not permitted.");
        onError(keys, error);
    }
    // Rejoice!
}
/**
 * Creates a copy and removes the empty strings from the object.
 *
 * @param {T} obj
 * @returns {T}
 */
function removeEmptyStrings(obj) {
    if (typeof obj !== "object") {
        return obj;
    }
    // Make a copy that will be mutated.
    // The <any> caste is to make TS happy
    // It says spread operators are only available on
    // object types, which T is since it extends it
    const copy = Object.assign({}, obj);
    Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (typeof value === "string" && value === "") {
            // delete the key on the copy, not the original
            delete copy[key];
        }
    });
    return copy;
}
//# sourceMappingURL=index.js.map